import { createSlice } from '@reduxjs/toolkit';
import { InternalApiFinalRiskLevel, InternalApiFinalRiskOverrideReasonPage } from '../api-internal';

export interface RiskState {
  overrideReasons: InternalApiFinalRiskOverrideReasonPage;
  finalRiskLevels: InternalApiFinalRiskLevel[];
}

const initialState: RiskState = {
  overrideReasons: {
    number: 0,
    size: 0,
    total: 0,
    content: [],
  },
  finalRiskLevels: [],
};

const riskSlice = createSlice({
  name: 'risk',
  initialState,
  reducers: {
    fetchRiskOverrideReasonPageSuccess: (state, action) => {
      state.overrideReasons = action.payload || initialState.overrideReasons;
    },
    fetchFinalRiskLevelsSuccess: (state, action) => {
      state.finalRiskLevels = action.payload || initialState.finalRiskLevels;
    },
  },
});

const { actions, reducer } = riskSlice;
export const { fetchRiskOverrideReasonPageSuccess, fetchFinalRiskLevelsSuccess } = actions;
export default reducer;
